import React from "react";
import { Paper, Box, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import MySharesTable from "../../components/MyShares/MySharesTable";

export default function SharedWithMeTab({
  items,
  classes,
  onDeleteItem,
  onOpenItem,
  loading,
  disabled,
}) {
  return (
    <Paper className={classes.paper} elevation={0}>
      <Box className={classes.paperHead}>
        <Typography variant="h1" component="h2" className={classes.title}>
          <FormattedMessage id="myShares.title.sharedWithMe" />
        </Typography>
      </Box>
      <Box className={classes.paperBody}>
        <MySharesTable
          items={items}
          withFromColumn
          onDeleteItem={onDeleteItem}
          onOpenItem={onOpenItem}
          loading={loading}
          disabled={disabled}
        />
      </Box>
    </Paper>
  );
}
